"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileScanResponseSchema = exports.WebScanResponseSchema = exports.LinkMobResponseSchema = void 0;
const zod_1 = require("zod");
const token_1 = require("../model/token");
const PromotionMisc = __importStar(require("../misc/promotion"));
exports.LinkMobResponseSchema = zod_1.z.array(PromotionMisc.LinkMobSchema);
exports.WebScanResponseSchema = zod_1.z.string();
const MobileScanPromotionSchema = zod_1.z.object({
    isUpcoming: zod_1.z.boolean(),
    isExpired: zod_1.z.boolean(),
    type: zod_1.z.literal("promotion"),
    tokens: zod_1.z.array(zod_1.z.union([token_1.AnimalPromotionSchema, token_1.ProductPromotionSchema, token_1.ProductSchema, token_1.BrandSchema]))
});
const MobileScanSecurityCodeSchema = zod_1.z.object({
    type: zod_1.z.enum(["item", "carton", "pallet"]),
    tokens: zod_1.z.array(zod_1.z.union([token_1.ProductSecurityCodeSchema, token_1.ProductSchema, token_1.BrandSchema]))
});
const MobileScanProductSchema = zod_1.z.object({
    type: zod_1.z.literal("product"),
    tokens: zod_1.z.array(zod_1.z.union([token_1.ProductSchema, token_1.BrandSchema]))
});
const MobileScanPlanSchema = zod_1.z.object({
    type: zod_1.z.literal("plant"),
    tokens: zod_1.z.array(zod_1.z.union([token_1.PlantSchema, token_1.AssetProfileSchema]))
});
exports.MobileScanResponseSchema = zod_1.z.union([MobileScanPromotionSchema, MobileScanSecurityCodeSchema, MobileScanProductSchema, MobileScanPlanSchema]);
